import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Do you sell saunas or only assemble them?",
    a: "We are an assembly-only service. You buy your sauna from any manufacturer you prefer — we handle delivery coordination, unboxing, and precision assembly.",
  },
  {
    q: "Which brands can you work with?",
    a: "Any brand available on the market — Harvia, Almost Heaven, Dundalk LeisureCraft, Auroom, Klafs, TyloHelo, Finnleo, and custom kits. If it comes with instructions (or even if it doesn't), we can build it.",
  },
  {
    q: "How long does a typical installation take?",
    a: "Indoor kits usually take 1–2 days. Outdoor barrel and cabin saunas typically take 1–3 days depending on foundation prep, chimney work, and finishing details.",
  },
  {
    q: "Do you handle electrical hookups?",
    a: "We coordinate with licensed electricians in your area and manage the process end-to-end so you don't have to juggle multiple trades.",
  },
  {
    q: "What's your service area?",
    a: "Columbus, Ohio and the surrounding Central Ohio communities. For larger installs, we travel — reach out and we'll quote transparently.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="border-t border-[#E5E0D8] bg-bone">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="overline mb-5">Frequently asked</p>
            <h2 className="font-serif-display font-light text-4xl md:text-5xl text-text-main leading-tight">
              A few things
              <br />
              <span className="italic text-cedar">worth knowing.</span>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <Accordion type="single" collapsible data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-[#E5E0D8]"
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="font-serif-display text-xl md:text-2xl text-text-main text-left hover:text-cedar py-6"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-text-muted text-base leading-relaxed pb-6 max-w-xl">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
